import type { GetStaticProps, NextPage } from "next";
import { PlanPage } from "src/domains/shared/components/Home/Plan/PlanPage";
import { SiteLayout } from "src/domains/shared/components/Home/SiteShell/SiteLayout";

const Plan: NextPage = () => (
  <SiteLayout>
    <PlanPage />
  </SiteLayout>
);

export const getStaticProps: GetStaticProps = () => {
  return {
    props: {},
  };
};

export default Plan;
